var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['backdrop', { 'fixed-top vh-100 vw-100': _vm.show }, { show: _vm.show, fade: _vm.fade }]},[_c('div',{staticClass:"fixed-center",style:([{ 'z-index': _vm.show ? 1071 : null }])},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }